<template>
    <v-dialog
      :value="dialog"
      width="310"
      :persistent="true"
      :no-click-animation="true"
      :overlay-opacity="0.7"
      content-class="dialog"
      :retain-focus="false"
    >
      <v-card>
        <v-card-text class="dialog-content">
          <div v-html="str"></div>
          <!-- {{str}} -->
        </v-card-text>
        <v-card-actions>
          <v-btn
            plain
            block
            :ripple="false"
            height="42"
            class="fs-16 fw-500"
            @click="$emit('close')"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
  export default {
      props:{
          dialog:Boolean,
          str:String
      },
  }
</script>
